// src/modules/restaurant/pages/orders/hooks/useOrderStatus.ts
import { OrderList } from "../types/orderTypes";

export const useOrderStatus = (order: OrderList | null) => {
  const status = order?.OrderStatus?.toLowerCase() || "";
  const isCancelled = status === "cancelled";
  const isCompleted = status === "completed";
  const statusLabel = isCancelled ? "Cancelled" : isCompleted ? "Completed" : "Active";
  const statusClass = isCancelled ? "text-red-600" : isCompleted ? "text-green-600" : "text-amber-600";

  return { isCancelled, isCompleted, statusLabel, statusClass };
};
